import { GenericValue, DynamicContent, Language } from 'hisng';
import { OrganizationPatent, PatentInventor } from 'app/fs/res/patent/model/patent/patent-classes';
import { ResearchContract } from 'app/fs/res/common/model/finance/research-contract-classes';
import { Project } from 'app/fs/res/finance/model/project/project';

export class Patent extends DynamicContent {
    id: number;
    objGuid: string;

    title: string; // not null
    priorityPatent: Patent;

    patentNumber: string;
    publicationNumber: string;

    grantDate: string | Date; // Date
    registrationDate: string | Date; // Date

    commentary: string;

    country: GenericValue;
    registrationType: GenericValue;
    language: Language;
    status: GenericValue;
    visibilityValue: GenericValue;

    researchAreas: GenericValue[] = [];
    researchAreasKdsf: GenericValue[] = [];
    subjectAreas: GenericValue[] = [];

    inventors: PatentInventor[] = [];
    projects: Project[] = [];
    researchContracts: ResearchContract[] = []; // Project and Patent could use the same object -> Rename backend!

    lockVersion: number;

    organizations: OrganizationPatent[] = [];

    // listviews
    listviews: Record<string, any>;

    constructor( id?: number, title?: string, patentNumber?: string, registrationDate?: string | Date, registrationType?: GenericValue) {
        super();
        this.id = id;
        this.title = title;
        this.patentNumber = patentNumber;
        this.registrationDate = registrationDate;
        this.registrationType = registrationType;
    }
}
